<template>
  <div class="interpolation-pad common_radius">
    <div class="search_wrapper">
      <div class="search_group">
        <div class="search_item">
          <span class="search_label">目标数据</span>
          <div class="search_input">
            <el-select v-model="channelSelected" :popper-append-to-body="false">
              <el-option
                :class="{
                  'is-interpolated': item.state == 1
                }"
                v-for="(item, index) in channelList"
                :key="index"
                :label="item.heights"
                :value="item.channelId"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search_group" v-if="channelSelected">
        <div class="search_item">
          <span class="search_label">参考数据</span>
          <div class="search_input">
            <el-select v-model="dataSetSelected" :popper-append-to-body="false">
              <el-option
                v-for="(item, index) in dataSetList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search_group" v-if="dataSetSelected === 0">
        <div class="search_item">
          <span class="search_label">数据源</span>
          <div class="search_input">
            <el-select
              v-model="dataSetNumSelected"
              @change="handleDatasetNumberChange"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in dataSetNumList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search_item">
          <span class="search_label">高层度</span>
          <div class="search_input">
            <el-select
              v-model="heightSelected"
              @change="handleHeightChange"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in heightList"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search_group" v-if="dataSetSelected === 1">
        <div class="search_item">
          <span class="search_label">参考塔</span>
          <div class="search_input">
            <el-select
              v-model="towerSelected"
              @change="handleTowerCodeChange"
              filterable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in towerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search_item">
          <span class="search_label">数据版本</span>
          <div class="search_input">
            <el-select
              @change="handleVersionChange"
              v-model="towerVersionSelected"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in versionList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="search_item">
          <span class="search_label">数据通道</span>
          <div class="search_input">
            <el-select
              v-model="channelTowerSelected"
              @change="handleChannelTowerChange"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in channelTowerList"
                :key="index"
                :label="item.heights"
                :value="item.channelId"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <ct-button :btn-click="compare" type="primary">缺失对比</ct-button>
        <ct-button v-if="isOwnerFlag == 1" :btn-click="reset">重置</ct-button>
      </div>
    </div>

    <template v-if="isShowScanPad">
      <div class="preview-box">
        <div class="preview-item">
          <div class="title">目标数据:</div>
          <div class="content">
            <div class="chart">
              <CustomeLine
                :startTime="startTime"
                :endTime="endTime"
                :types="realDataList"
              ></CustomeLine>
            </div>
            <!-- <div class="memo">
              <span>实际点数/应用点数: {{ dataText }}</span
              >&nbsp;&nbsp;
              <span>完整率: {{ dataRate }} %</span>
            </div>-->
          </div>
        </div>
        <!-- <div class="bar"></div> -->
        <div class="preview-item">
          <div class="title">
            参考数据:
            <!-- {{
              dataSetSelected == 1
                ? '测风塔:' + selectTowerNo
                : `中尺度数据: ${dataSetNumSelected} ${heightSelected}`
            }}-->
          </div>
          <div class="content">
            <div class="chart">
              <CustomeLine
                :types="refDataList"
                :startTime="startTime"
                :endTime="endTime"
              ></CustomeLine>
            </div>
            <!-- <div class="memo">
              <span>实际点数/应用点数: {{ refDataText }}</span
              >&nbsp;&nbsp;
              <span>完整率: {{ refDataRate }} %</span>
            </div>-->
          </div>
        </div>
      </div>
      <div class="time-choose">
        <div class="desc">
          <span class="label">时间范围:</span>
          <span>{{ timeRangeText }}</span>
        </div>
      </div>

      <div style="margin: 20px 0px">
        <ct-button :btn-click="handleCheckRelative" type="primary"
          >查看相关性</ct-button
        >
      </div>

      <template v-if="isShowRelativeChart">
        <div class="correct-data-chart-wrapper">
          <div class="correct-data-chart">
            <Chart :option="chartOption" class="charts"></Chart>
            <div class="plus-content" v-if="this.a || this.RSquare">
              y={{ this.a }}x{{ this.b >= 0 ? '+' : '' }}{{ this.b }}<br />
              R²={{ this.RSquare }}
            </div>
          </div>
          <div style="margin-top: 10px">
            <ct-button
              v-if="isOwnerFlag == 1"
              :btn-click="handleSaveTrim"
              type="primary"
              >应用修改</ct-button
            >
          </div>
        </div>
      </template>

      <template v-if="isShowLastChart">
        <div class="last-result-chart">
          <Chart :option="lastChartOption"></Chart>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import Chart from '../components/chart';
import CustomeLine from '../components/custome-line';
import { getIntergrityInterval } from '../../../utils';
// import { mapState } from 'vuex';

export default {
  components: {
    CustomeLine,
    Chart
  },
  data() {
    return {
      lastChartOption: {},
      isShowLastChart: false,
      chartOption: {},
      dataRate: '',
      refDataRate: '',
      dataText: '',
      refDataText: '',
      isShowRelativeChart: false,
      versionList: [],
      timePharse: 0,
      towerVersionSelected: '',
      channelTowerSelected: '',
      channelSelected: '',
      channelList: [],
      dataSetSelected: '',
      towerSelected: '',
      towerList: [],
      channelTowerList: [],
      dataSetNumSelected: '',
      heightSelected: '',
      heightList: [],
      dataSetNumList: [],
      dataSetList: [
        {
          name: '中尺度数据',
          id: 0
        },
        {
          name: '测风塔',
          id: 1
        }
      ],

      date: [],
      isShowScanPad: false,
      refDataList: [],
      realDataList: [],
      lineData: [],
      timeRangeText: '',
      startTime: '',
      endTime: ''
    };
  },
  computed: {
    // ...mapState('WindData', ['SelectVersionId', 'selectTowerId']),
    channelSelectedName() {
      if (!this.channelSelected) {
        return '';
      }
      return (
        this.channelList.find(i => i.channelId === this.channelSelected)
          .channelName || ''
      );
    },
    selectTowerNo() {
      return this.towerList.find(i => i.id === this.towerSelected).name || '';
    },
    isOwnerFlag: function() {
      let towerObj = this.$store.state.WindData.towerObj || {};
      let { isOwnerFlag } = towerObj;
      return isOwnerFlag;
    },
    SelectVersionId() {
      let towerObj = this.$store.state.WindData.towerObj || {};
      let { versionId } = towerObj;
      return versionId;
    },
    selectTowerId() {
      let towerObj = this.$store.state.WindData.towerObj || {};
      let { towerId } = towerObj;
      return towerId;
    }
  },

  watch: {
    selectTowerId() {
      this.queryDataSet();
    },
    SelectVersionId() {
      this.isShowScanPad = false;
      this.isShowRelativeChart = false;
      this.isShowLastChart = false;
      this.resetCore();
      this.queryChannelList();
    }
  },

  created() {
    this.queryChannelList();
    this.queryDataSet();
    this.queryTowerList();
  },
  mounted() {},
  methods: {
    handleHeightChange() {
      this.handleRescanClick();
    },
    handleChannelTowerChange() {
      this.handleRescanClick();
    },
    handleVersionChange(versionId) {
      this.channelTowerSelected = null;
      this.handleQuerySelectChannel(this.towerSelected, versionId);
      this.handleRescanClick();
    },
    handleQuerySelectChannel(towerId, versionId) {
      this.$fetch('/winddata/dataInterpolation/getChannelList', {
        module: 'windData',
        showError: true,
        params: {
          towerId,
          versionId
        }
      }).then(res => {
        const { data = {} } = res || {};
        const { channelList } = data;

        this.channelTowerList = channelList;
      });
    },

    handleTowerCodeChange(val) {
      this.towerVersionSelected = null;
      this.channelTowerSelected = null;
      const item = this.towerList.find(i => val === i.id) || null;
      if (item) {
        this.versionList = item.versionList || [];
      }
      this.handleRescanClick();
    },
    queryTowerList() {
      this.$fetch('/winddata/dataProcess/getDataProcessMenu', {
        module: 'windData',
        showError: true
      }).then(res => {
        const { data = {} } = res;
        let { menu = [] } = data;
        const towerList = menu;
        this.towerList = towerList.map(tower => {
          return {
            id: tower.towerId,
            name: tower.towerName || tower.towerCode,
            versionList: tower.towerVersionList.map(version => ({
              id: version.versionId,
              name: version.versionName
            }))
          };
        });
        // this.channelTowerList = this.channelList;
      });
    },
    handleDatasetNumberChange(val) {
      this.heightSelected = '';
      this.heightList = this.dataSetNumList.find(i => i.id === val).heightList;
      this.handleRescanClick();
      this.isShowRelativeChart = false;
      this.isShowLastChart = false;
    },
    queryDataSet() {
      this.$fetch('/winddata/dataProcess/getDataSet', {
        showError: true,
        module: 'windData'
      }).then(res => {
        const { data = {} } = res;
        const { dataSetList = [] } = data;

        this.dataSetNumList = dataSetList.map(i => {
          return {
            id: i.datasetCode,
            name: i.datasetName,
            heightList: i.datasetHeight.map(i => ({
              name: i + 'm',
              value: i
            }))
          };
        });

        const firstItem = this.dataSetNumList[0] || {};
        this.dataSetNumSelected = firstItem.id || '';
        this.dataSetSelected = 0;
        // this.handleDatasetNumberChange(this.dataSetNumSelected);

        this.heightSelected =
          (firstItem.heightList[0] && firstItem.heightList[0].value) || '';

        this.heightList = firstItem.heightList;
      });
    },
    queryChannelList() {
      if (!this.SelectVersionId && !this.selectTowerId) return;
      this.$fetch('/winddata/dataInterpolation/getChannelList', {
        showLoading: true,
        params: {
          versionId: this.SelectVersionId,
          towerId: this.selectTowerId
        },
        showError: true,
        module: 'windData'
      }).then(res => {
        const { data = {} } = res;
        const { channelList = [] } = data;
        this.channelList = channelList;

        const firstItem = this.channelList[0] || {};

        this.channelSelected = firstItem.channelId || '';
      });
    },
    compare() {
      let requestUrl = '/winddata/dataInterpolation/getMesChannelData';
      let params = {
        channelId: this.channelSelected,
        towerId: this.selectTowerId,
        versionId: this.SelectVersionId
      };
      if (this.dataSetSelected != 0) {
        if (
          !this.channelSelected ||
          !this.channelTowerSelected ||
          !this.towerVersionSelected
        ) {
          return this.$message.warning('请填写完整表单');
        }
        requestUrl = '/winddata/dataInterpolation/getChannelData';
        params.refChannelId = this.channelTowerSelected;
        params.refVersionId = this.towerVersionSelected;
      } else {
        if (
          !this.channelSelected ||
          !this.dataSetNumSelected ||
          !this.heightSelected
        ) {
          return this.$message.warning('请填写完整表单');
        }
        params.dataSet = this.dataSetNumSelected;
        params.height = this.heightSelected;
      }

      this.$fetch(requestUrl, {
        showError: true,
        showLoading: true,
        module: 'windData',
        params
      }).then(res => {
        const { data = {} } = res;
        const {
          refDataList = [],
          dataList = [],
          startDate,
          endDate,
          actualCount,
          count,
          refActualCount,
          refCount,
          rate = 0,
          refRate = 0
        } = data;
        let timeStampArr = [];
        let rawArr = [];
        let rawArr_2 = [];

        refDataList.forEach((i, index) => {
          timeStampArr.push(i[0]);
          rawArr.push(i[1]);

          rawArr_2[index] = (dataList[index] && dataList[index][1]) || 0;
        });

        this.dataText = `${actualCount}/${count}`;
        this.refDataText = `${refActualCount}/${refCount}`;

        this.timeRangeText = `${startDate} 至 ${endDate}`;
        this.dataRate = rate;
        this.refDataRate = refRate;

        this.startTime = refDataList[0] && refDataList[0][0];
        this.endTime =
          refDataList[refDataList.length - 1] &&
          refDataList[refDataList.length - 1][0];

        const item = {
          value: getIntergrityInterval(rawArr, timeStampArr, 0, {
            normal: {
              color: '#f5222d'
            }
          })
        };
        this.refDataList = [item];

        const another = {
          value: getIntergrityInterval(rawArr_2, timeStampArr, 0, {
            normal: {
              color: '#063772'
            }
          })
        };

        this.isShowRelativeChart = false;
        this.realDataList = [another];
        this.isShowScanPad = true;
      });
    },
    handleRescanClick() {
      this.isShowScanPad = false;
    },
    handleCheckRelative() {
      let requestUrl = '';
      let params = {
        towerId: this.selectTowerId,
        versionId: this.SelectVersionId,
        channelId: this.channelSelected
      };
      if (this.dataSetSelected == 0) {
        requestUrl = '/winddata/dataInterpolation/getMesCorrectData';
        params.dataSet = this.dataSetNumSelected;
        params.height = this.heightSelected;
      } else {
        requestUrl = '/winddata/dataInterpolation/getCorrectData';
        params.refChannelId = this.channelTowerSelected;
        params.refVersionId = this.towerVersionSelected;
      }
      this.$fetch(requestUrl, {
        showError: true,
        showLoading: true,
        module: 'windData',
        params
      }).then(res => {
        const { data } = res;
        this.handleRelativeData(data);
        this.isShowRelativeChart = true;
      });
    },
    reset() {
      if (!this.channelSelected) return this.$message.warning('未选择通道对比');
      this.$postForm('/winddata/dataInterpolation/resetInterpolationData', {
        data: {
          towerId: this.selectTowerId,
          versionId: this.SelectVersionId,
          channelId: this.channelSelected
        },
        module: 'windData',
        showError: true,
        showSuccess: true,
        showLoading: true
      }).then(() => {
        this.handleRescanClick();
        this.isShowRelativeChart = false;
        this.isShowLastChart = false;
        //this.resetCore();
      });
    },
    resetCore() {
      this.channelSelected = '';
      this.dataSetSelected = '';
      this.dataSetNumSelected = '';
      this.heightSelected = '';

      this.towerSelected = '';
      this.towerVersionSelected = '';
      this.channelTowerSelected = '';
    },
    getUnit(prefix = false) {
      let typeId = this.channelList.filter(
        item => item.channelId == this.channelSelected
      )[0].typeId;
      if (typeId == 1) {
        return prefix ? '风速（m/s）' : '（m/s）';
      } else if (typeId == 6) {
        return prefix ? '气压（kPa）' : '（kPa）';
      } else if (typeId == 3) {
        return prefix ? '风向（°）' : '（°）';
      } else if (typeId == 5) {
        return prefix ? '气温（℃）' : '（℃）';
      }
    },
    handleSaveTrim() {
      const url =
        this.dataSetSelected == 0
          ? '/winddata/dataInterpolation/saveMesCorrectData'
          : '/winddata/dataInterpolation/saveDataInterpolation';

      const params =
        this.dataSetSelected == 0
          ? {
              a: this.a,
              b: this.b,
              channelId: this.channelSelected,
              dataSet: this.dataSetNumSelected,
              height: this.heightSelected,
              towerId: this.selectTowerId,
              versionId: this.SelectVersionId
            }
          : {
              a: this.a,
              b: this.b,
              channelId: this.channelSelected,
              refChannelId: this.channelTowerSelected,
              refVersionId: this.towerVersionSelected,
              towerId: this.selectTowerId,
              versionId: this.SelectVersionId
            };

      this.$postForm(url, {
        showError: true,
        showSuccess: true,
        module: 'windData',
        showLoading: true,
        data: params
      }).then(res => {
        const { data = {} } = res;
        let { refDataList = [], dataList = [] } = data;

        this.isShowLastChart = true;

        this.lastChartOption = {
          textStyle: {
            color: '#222233'
          },
          grid: {
            left: 40,
            top: 30,
            bottom: 30,
            right: 50
          },
          xAxis: {
            name: '时间',
            type: 'time',
            scale: true,
            boundaryGap: false,
            // inverse: true,
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            min: 'dataMin',
            max: 'dataMax'
          },
          yAxis: {
            name: this.getUnit(true),
            scale: true,
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            }
          },
          backgroundColor: '#fff',
          series: [
            {
              type: 'scatter',
              symbol: 'circle',
              symbolSize: 3,
              // showSymbol: false,
              large: true,
              data: dataList,
              lineStyle: {
                color: '#40a9ff'
              },
              itemStyle: {
                color: '#40a9ff'
              },
              animation: false
            },
            {
              type: 'scatter',
              symbol: 'circle',
              symbolSize: 3,
              // showSymbol: false,
              data: refDataList,
              large: true,
              lineStyle: {
                color: '#a8071a'
              },
              itemStyle: {
                color: '#a8071a'
              },
              animation: false
            }
          ]
        };
      });
    },
    handleRelativeData(data) {
      const {
        avgScatterDataList = [],
        correlationList = [],
        a = null,
        b = null,
        RSquare = null
      } = data;
      this.RSquare = RSquare;
      this.a = a;
      this.b = b;

      this.chartOption = {
        textStyle: {
          color: '#222233'
        },
        grid: {
          left: 60,
          top: 30,
          bottom: 30,
          right: 110
        },
        xAxis: {
          name: '参考数据' + this.getUnit(),
          // type: 'time',
          scale: true,
          boundaryGap: false,
          // inverse: true,
          axisLine: {
            onZero: false,
            lineStyle: {
              color: '#222233'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          min: 0,
          max: value => {
            if (value.max <= 10) {
              return 12;
            }

            let max = value.max * 1.2;
            let val = max / 5;
            const round = true;
            const exponent = Math.floor(Math.log(val) / Math.LN10);
            const exp10 = Math.pow(10, exponent);
            const f = val / exp10; // 1 <= f < 10
            let nf;
            if (round) {
              if (f < 1.5) {
                nf = 1;
              } else if (f < 2.5) {
                nf = 2;
              } else if (f < 4) {
                nf = 3;
              } else if (f < 7) {
                nf = 5;
              } else {
                nf = 10;
              }
            } else {
              if (f < 1) {
                nf = 1;
              } else if (f < 2) {
                nf = 2;
              } else if (f < 3) {
                nf = 3;
              } else if (f < 5) {
                nf = 5;
              } else {
                nf = 10;
              }
            }
            val = nf * exp10;
            return val * 5 <= value.max ? val * 6 : val * 5;
          }
        },
        yAxis: {
          name: '目标数据' + this.getUnit(),
          scale: true,
          min: 0,
          max: value => {
            if (value.max <= 10) {
              return 12;
            }

            let max = value.max * 1.2;
            let val = max / 5;
            const round = true;
            const exponent = Math.floor(Math.log(val) / Math.LN10);
            const exp10 = Math.pow(10, exponent);
            const f = val / exp10; // 1 <= f < 10
            let nf;
            if (round) {
              if (f < 1.5) {
                nf = 1;
              } else if (f < 2.5) {
                nf = 2;
              } else if (f < 4) {
                nf = 3;
              } else if (f < 7) {
                nf = 5;
              } else {
                nf = 10;
              }
            } else {
              if (f < 1) {
                nf = 1;
              } else if (f < 2) {
                nf = 2;
              } else if (f < 3) {
                nf = 3;
              } else if (f < 5) {
                nf = 5;
              } else {
                nf = 10;
              }
            }
            val = nf * exp10;
            return val * 5 <= value.max ? val * 6 : val * 5;
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#222233'
            }
          }
        },
        tooltip: {
          show: false,
          alwaysShowContent: false
        },
        backgroundColor: '#fff',
        series: [
          {
            type: 'scatter',
            data: correlationList,
            symbolSize: 3,
            animation: false
          },
          {
            type: 'line',
            data: avgScatterDataList,
            zlevel: 1,
            lineStyle: {
              color: '#40a9ff'
            },
            animation: false
          }
        ]
      };
    }
  }
};
</script>
<style lang="less" scoped>
.correct-data-chart-wrapper {
  box-sizing: border-box;
  padding: 10px;
  //background-color: #333;
}

.correct-data-chart {
  margin-top: 10px;
  height: 400px;
  display: flex;
  .charts {
    flex: 1;
  }
  .plus-content {
    font-size: 14px;
    color: #888899;
    // line-height: 38px;
    width: 150px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 38px;

    span {
    }
  }
}

.preview-box {
  margin-top: 20px;
}

.line-detail {
  display: flex;
}
.interpolation-pad {
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
  // overflow: auto;
  background: rgb(240, 245, 250);
  .name {
    margin-right: 10px;
  }
  .echarts-content {
    height: 400px;
  }

  .opearte-box {
    margin-bottom: 10px;
  }

  .preview-box {
    .preview-item {
      display: flex;
      align-items: center;
      .title {
        // margin-right: 5px;
        font-size: 16px;
        color: #222233;
        // text-align: right;
        width: 70px;
        font-size: 14px;
        // margin-right: 10px;
      }
      .content {
        flex: 1;
        align-items: center;
        .chart {
          // padding: 5px 0px;
          height: 25px;
        }
      }
    }
  }
  .bar {
    height: 1px;
    background-color: #000;
  }

  .time-choose {
    margin-top: 5px;
    display: flex;
    align-items: center;
    color: #222233;
    .desc {
      color: #222233;
      font-size: 14px;
      .label {
        display: inline-block;
        width: 70px;
        // margin-right: 10px;
        // text-align: right;
      }
    }
    .btn-box-s {
      margin-left: 20px;
    }
  }
}

.last-result-chart {
  margin-top: 10px;
  height: 400px;
}
</style>
<style lang="less" scoped>
.search {
  &_wrapper {
    background: #2f6ba44d;
    padding: 13px 20px 13px 10px;
    border-radius: 8px;
    position: relative;
    .btn-box {
      text-align: right;
      span:first-child {
        margin-right: 15px;
      }
    }
  }
  &_group {
    display: flex;
    margin-bottom: 15px;
  }
  &_label {
    font-size: 16px;
    font-weight: bold;
    color: #222233;
    margin-right: 10px;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: right;
    width: 90px;
  }
  &_item {
    display: flex;
    align-items: center;
  }
  &_input {
    flex: 1;
  }
}
</style>
